import { observeOnce, prefersReducedMotion } from '@kame/lib';

class KameFaq extends HTMLElement {
  connectedCallback() {
    if (prefersReducedMotion()) return;
    this.classList.add('is-armed');
    this.reveal = observeOnce(this, () => this.classList.add('is-inview'), '0px 0px -10% 0px');
  }

  disconnectedCallback() {
    this.reveal?.disconnect();
  }
}

if (!customElements.get('kame-faq')) customElements.define('kame-faq', KameFaq);
